// extracted by mini-css-extract-plugin
export default {"date":"_1UAy6","eventList":"_2eIj2","dateText":"_3a2gO","eventDetails":"IXRs5","dateWithChevron":"pUgKP","dateChevron":"_2Zcoo","close":"_2gR_G"};